/* eslint-disable no-nested-ternary */
import styles from "./ChatLinks.module.scss";
import config from "@Config/index";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
// import FacebookIcon from "@Icons/FacebookIcon";
import handleChatWidgetOpen from "helpers/handleChatWidgetOpen";
import { PHONE_5, WHATSAPP_URL } from "constants/configConstants";
import getWeComUrlBasedOnSource, { HK_WEIXIN_MWEB } from "helpers/getWeComUrlBasedOnSource";
import useTranslationHook from "hooks/useTranslationHook";
import WechatFilled from "@Icons/WechatFilled";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { GROWTH_BOOK_FEATURE_FLAG_NAMES } from "constants/index";
import { addLoadZendeskParamInURL } from "@Pages/PropertyPage/data/helper";
import LoginDispatcher from "@Components/Login/actions";
import { AppState } from "@Store/index";
import openCopilotFromModal from "@Utils/openCopilotFromModal";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";
import getCountryNumber from "@Pages/Support/utils";
import ChatIconPropertyPageBottom from "@Icons/ChatIconPropertyPageBottom";
import PhoneIcon from "@Icons/PhoneIcon";
import WhatsAppIcon from "@Icons/WhatsAppIcon";
import useIsMiniProgram from "hooks/useIsMiniProgram";
import WhitelabelPartnerWeChatQr from "@Components/Header/components/WhitelabelPartnerWeChatQr";
import emitAiChatInitiatedEvent from "helpers/emitAiChatInitiatedEvent";
import CustomLink from "@Components/CustomLink";
import useCustomWindowLocation from "@Components/CustomWindowLocation";
import { useEffect, useState } from "react";
import useIsApp from "hooks/useIsApp";

const ChatLinks = ({ onClose }: { onClose: () => void }) => {
  const customWindowLocation = useCustomWindowLocation();
  const { isUserLoggedIn, isLFOneFilled, country } = useSelector(
    ({ appData, leadFormModal }: AppState) => ({
      isUserLoggedIn: appData.isUserLoggedIn,
      country: appData.country,
      isLFOneFilled: leadFormModal.isLFOneFilled,
    }),
    shallowEqual,
  );
  const { isWhitelabel, partner_id } = useWhitelabel();
  const dispatch = useDispatch();
  const isMiniProgram = useIsMiniProgram();
  const isApp = useIsApp();
  const [weChatSupportRedirectTo, setWeChatSupportRedirectTo] = useState(HK_WEIXIN_MWEB);
  const isZendeskAfterLogin = useFeatureIsOn(GROWTH_BOOK_FEATURE_FLAG_NAMES.ZENDESK_LOGIN_POPUP);
  const isAmberCopilotEnabled = useFeatureIsOn(GROWTH_BOOK_FEATURE_FLAG_NAMES.AMBER_COPILOT);
  const number = config.IS_CHINA_APP ? PHONE_5.full_number : getCountryNumber(country);
  const onClickIntercom = async () => {
    if (isMiniProgram) {
      customWindowLocation({ url: `${window.location.origin}/chat` });
      return;
    }
    if (isAmberCopilotEnabled) {
      emitAiChatInitiatedEvent();
      openCopilotFromModal(dispatch, onClose);
      return;
    }
    if (isZendeskAfterLogin && !isUserLoggedIn && !isLFOneFilled) {
      addLoadZendeskParamInURL();
      const loginDispatcher = new LoginDispatcher(dispatch);
      loginDispatcher.showLoginModal({ openingSource: "zendesk" });
    } else {
      await handleChatWidgetOpen(true);
    }
    onClose();
  };
  const { t } = useTranslationHook();

  const showWhitelabelWeChatSupportQR = partner_id == "93557";

  useEffect(() => {
    const { URLMweb } = getWeComUrlBasedOnSource();
    setWeChatSupportRedirectTo(URLMweb);
  }, []);

  return (
    <div className={styles.container}>
      {!isWhitelabel && (
        <>
          <div
            data-testid="property-support-chatOnWebsite"
            className={styles.btn}
            role="none"
            onClick={onClickIntercom}
          >
            <ChatIconPropertyPageBottom />
            <span> {t("propertypage.components.chatlinks.chatwithus")}</span>
          </div>

          <CustomLink
            data-testid="property-support-number"
            href={`tel:${number}`}
            target="_blank"
            rel="noreferrer"
            className={formatClassNames(styles.btn)}
            isExternal
            openInExternalBrowserOfApp={isApp}
          >
            <PhoneIcon />
            <span>{t("propertypage.components.chatlinks.callus")}</span>
          </CustomLink>
        </>
      )}
      {config.IS_CHINA_APP ? (
        <CustomLink
          data-testid="property-support-WhatsAppsChat"
          href={weChatSupportRedirectTo}
          target="_blank"
          rel="noreferrer"
          className={formatClassNames(styles.btn)}
          isExternal
          openInExternalBrowserOfApp={isApp}
        >
          <WechatFilled />
          <span>{t("propertypage.components.chatlinks.wechat")}</span>
        </CustomLink>
      ) : !showWhitelabelWeChatSupportQR ? (
        <CustomLink
          data-testid="property-support-WhatsAppsChat"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noreferrer"
          className={formatClassNames(styles.btn)}
          isExternal
          openInExternalBrowserOfApp={isApp}
        >
          <WhatsAppIcon />
          <span>{t("propertypage.components.chatlinks.whatsappus")}</span>
        </CustomLink>
      ) : (
        <>
          <WhitelabelPartnerWeChatQr showSupportText={false} />
        </>
      )}
    </div>
  );
};

export default wrapperHOC(ChatLinks, {
  componentName: "ChatLinks-PropertyPage",
  showForChina: true,
});
